<template>
  <div class="u-df">
    <b-field :label="$t('Tipo de zona')" class="field--contents-inline">
      <b-select v-model="combinationFactors.id">
        <option v-for="option in options" :key="option.id" :value="option.id">
          {{ $t(option.text) }}
        </option>
      </b-select>
    </b-field>

    <div class="u-df">
      <b-field label="Ψ0" class="phiField field--contents-inline">
        <calc-number-input
          class="phiField__input"
          v-model="combinationFactors.value[0]"
          :precision="2"
          :step="0.01"
          :min="0"
          :max="30"
        />
      </b-field>

      <b-field label="Ψ1" class="phiField field--contents-inline">
        <calc-number-input
          class="phiField__input"
          v-model="combinationFactors.value[1]"
          :precision="2"
          :step="0.01"
          :min="0"
          :max="30"
        />
      </b-field>

      <b-field label="Ψ2" class="phiField field--contents-inline">
        <calc-number-input
          class="phiField__input"
          v-model="combinationFactors.value[2]"
          :precision="2"
          :step="0.01"
          :min="0"
          :max="30"
        />
      </b-field>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Flag } from "@/utils";

export default {
  props: {
    theCase: {
      required: true,
      type: String,
      validator: (val) => ["wind", "live", "snow"].includes(val),
    },
  },

  data() {
    return {
      flag: new Flag(),
    };
  },

  computed: {
    ...mapState(["calculationData"]),
    ...mapState("calculator", ["calculation"]),

    location() {
      return this.calculation.input.location;
    },

    combinationFactors: {
      get() {
        return this.calculation.input.combinationFactors[this.theCase];
      },
      set(val) {
        this.calculation.input.combinationFactors[this.theCase] = val;
      },
    },

    options() {
      const phis = this.calculationData.constants.phis;

      if (this.theCase === "live") {
        return phis[this.theCase][`type-${this.calculation.input.type}`].list[
          this.location
        ];
      } else {
        return phis[this.theCase].list[this.location];
      }
    },

    fixedOptions() {
      return this.options.filter(({ id }) => id !== 0);
    },

    userDefinedOption() {
      return this.options.find(({ id }) => id == 0);
    },
  },

  watch: {
    "combinationFactors.id"(newId) {
      if (this.flag.test("idChangeFromValue")) return;
      this.flag.create("valueChangeFromId");

      const option = this.getOptionById(newId);
      const newValue = [...option.value];

      this.combinationFactors.value = newValue;
    },
    "combinationFactors.value"(newValue) {
      if (this.flag.test("valueChangeFromId")) return;
      this.flag.create("idChangeFromValue");

      const option = this.getOptionByValue(newValue);
      const newId = option.id;

      this.combinationFactors.id = newId;
    },
  },

  methods: {
    getOptionById(id) {
      return this.options.find((option) => {
        return id === option.id;
      });
    },
    getOptionByValue(value) {
      return (
        this.fixedOptions.find((option) => {
          const [a0, a1, a2] = option.value;
          return value[0] == a0 && value[1] == a1 && value[2] == a2;
        }) || this.userDefinedOption
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.phiField {
  margin-left: 16px;
}
.phiField__input {
  width: 64px;
}
</style>
